import React from 'react';
import StatusOval from '../components/StatusOval';

const Avatar = ({cx, cy, r, fill, initials, fontSize = 11, strokeWidth = 2, stroke = '#FFFFFF'}) => (
    <>
        <circle cx={cx} cy={cy} r={r} fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
        <text x={cx} y={cy + fontSize * 0.35} fontSize={fontSize} fontWeight="600" fill="#FFFFFF" textAnchor="middle">
            {initials}
        </text>
    </>
);

// The homepage hero product mock: an app bar, lanes of status ovals joined by
// arrows, avatar chips and a task details panel. Purely decorative — labelled
// as a single role="img" per the accessibility brief.
export const HeroProductMockDesktop = () => (
    <svg width="1280" height="640" viewBox="0 0 1280 640" role="img"
         aria-label="Ovalview project map showing tasks as colour-coded ovals across team lanes"
         style={{display: 'block', fontFamily: "'Geist', sans-serif", width: '100%', height: 'auto'}}>
        <defs>
            <pattern id="ov-hero-dots" width="20" height="20" patternUnits="userSpaceOnUse">
                <circle cx="1" cy="1" r="1" fill="#E3E0D7"/>
            </pattern>
            <marker id="ov-hero-arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7"
                    orient="auto-start-reverse">
                <path d="M0 0L10 5L0 10z" fill="#8A877E"/>
            </marker>
        </defs>
        <rect width="1280" height="640" fill="#FFFFFF"/>
        <g transform="translate(24 20)">
            <ellipse cx="7" cy="8" rx="6" ry="5" fill="#FDECEC" stroke="#E5484D" strokeWidth="1.5"/>
            <ellipse cx="13" cy="8" rx="6" ry="5" fill="#FEF4DE" stroke="#F5A524" strokeWidth="1.5"/>
            <ellipse cx="19" cy="8" rx="6" ry="5" fill="#E4F5EB" stroke="#30A46C" strokeWidth="1.5"/>
        </g>
        <text x="62" y="33" fontSize="14" fill="#8A887F">Projects</text>
        <text x="124" y="33" fontSize="14" fill="#C4C1B8">/</text>
        <text x="138" y="33" fontSize="14" fontWeight="600" fill="#141416">Checkout revamp</text>
        <Avatar cx={1102} cy={28} r={14} fill="#6E56CF" initials="AK"/>
        <Avatar cx={1124} cy={28} r={14} fill="#0D74CE" initials="JM"/>
        <Avatar cx={1146} cy={28} r={14} fill="#C2410C" initials="SR"/>
        <rect x="1176" y="12" width="80" height="32" rx="16" fill="#141416"/>
        <text x="1216" y="33" fontSize="13" fontWeight="600" fill="#FFFFFF" textAnchor="middle">Share</text>
        <line x1="0" y1="56" x2="1280" y2="56" stroke="#ECEAE3"/>
        <rect x="0" y="57" width="920" height="583" fill="#FBFAF7"/>
        <rect x="0" y="57" width="920" height="583" fill="url(#ov-hero-dots)"/>
        <line x1="920" y1="56" x2="920" y2="640" stroke="#ECEAE3"/>
        <rect x="24" y="84" width="44" height="148" rx="12" fill="#FFFFFF" stroke="#E6E4DC"/>
        <rect x="30" y="90" width="32" height="32" rx="8" fill="#F1EFE8"/>
        <ellipse cx="46" cy="106" rx="10" ry="7" fill="none" stroke="#141416" strokeWidth="1.6"/>
        <rect x="37" y="143" width="18" height="16" rx="3" fill="none" stroke="#6B6A72" strokeWidth="1.6"/>
        <circle cx="46" cy="190" r="4" fill="none" stroke="#6B6A72" strokeWidth="1.6"/>
        <path d="M38 204c1-5 5-7 8-7s7 2 8 7" fill="none" stroke="#6B6A72" strokeWidth="1.6" strokeLinecap="round"/>
        <g fontFamily="'Geist Mono', monospace" fontSize="12" fill="#9A978D" textAnchor="middle" letterSpacing="0.06em">
            <text x="200" y="108">DESIGN</text>
            <text x="400" y="108">FRONTEND</text>
            <text x="600" y="108">BACKEND</text>
            <text x="800" y="108">QA</text>
        </g>
        <g stroke="#E4E1D8" strokeWidth="2">
            <line x1="200" y1="124" x2="200" y2="600"/>
            <line x1="400" y1="124" x2="400" y2="600"/>
            <line x1="600" y1="124" x2="600" y2="600"/>
            <line x1="800" y1="124" x2="800" y2="600"/>
        </g>
        <g fill="none" stroke="#8A877E" strokeWidth="2" markerEnd="url(#ov-hero-arrow)">
            <path d="M272 172 C 310 172, 312 232, 326 232"/>
            <path d="M472 234 C 510 234, 512 302, 526 302"/>
            <path d="M400 260 L 400 352"/>
        </g>
        <g fill="none" stroke="#A9A69C" strokeWidth="2" strokeDasharray="6 6" markerEnd="url(#ov-hero-arrow)">
            <path d="M672 304 C 710 304, 712 382, 726 382"/>
            <path d="M472 384 C 510 384, 512 472, 526 472"/>
            <path d="M800 410 L 800 512"/>
            <path d="M672 474 C 710 474, 712 540, 726 540"/>
        </g>
        <StatusOval cx={200} cy={170} status="done" label="Wireframes"/>
        <StatusOval cx={400} cy={232} status="done" label="API contract"/>
        <ellipse cx="600" cy="302" rx="80" ry="34" fill="none" stroke="#3346E0" strokeWidth="1.5" strokeDasharray="4 4"/>
        <StatusOval cx={600} cy={302} status="doing" label="Payment flow"/>
        <StatusOval cx={400} cy={382} status="doing" label="Cart UI"/>
        <StatusOval cx={800} cy={382} status="todo" label="Regression"/>
        <StatusOval cx={600} cy={472} status="todo" label="Load test"/>
        <StatusOval cx={800} cy={540} status="todo" label="Release"/>
        <Avatar cx={662} cy={278} r={13} fill="#6E56CF" initials="AK" fontSize={10}/>
        <Avatar cx={462} cy={358} r={13} fill="#0D74CE" initials="JM" fontSize={10}/>
        <Avatar cx={862} cy={358} r={13} fill="#C2410C" initials="SR" fontSize={10}/>
        <rect x="24" y="584" width="268" height="36" rx="18" fill="#FFFFFF" stroke="#E6E4DC"/>
        <g fontSize="12" fontWeight="500" fill="#45444B">
            <circle cx="44" cy="602" r="5" fill="#E5484D"/>
            <text x="56" y="606">Not done</text>
            <circle cx="132" cy="602" r="5" fill="#F5A524"/>
            <text x="144" y="606">In progress</text>
            <circle cx="232" cy="602" r="5" fill="#30A46C"/>
            <text x="244" y="606">Done</text>
        </g>
        <text x="948" y="96" fontSize="13" fontWeight="600" fill="#8A887F" letterSpacing="0.04em">DETAILS</text>
        <text x="948" y="136" fontFamily="'Geist Mono', monospace" fontSize="13" fill="#8A887F">JRA-123</text>
        <text x="948" y="166" fontFamily="'Bricolage Grotesque', sans-serif" fontSize="24" fontWeight="700"
              fill="#141416">Payment flow</text>
        <rect x="948" y="184" width="104" height="26" rx="13" fill="#FEF4DE"/>
        <circle cx="962" cy="197" r="4" fill="#F5A524"/>
        <text x="972" y="201" fontSize="12" fontWeight="600" fill="#A15C07">In progress</text>
        <text x="948" y="246" fontSize="13" fill="#8A887F">Assignee</text>
        <Avatar cx={1102} cy={242} r={11} fill="#6E56CF" initials="AK" fontSize={9}/>
        <text x="1120" y="246" fontSize="13" fontWeight="500" fill="#141416">A. Khan</text>
        <text x="948" y="280" fontSize="13" fill="#8A887F">Lane</text>
        <text x="1092" y="280" fontSize="13" fontWeight="500" fill="#141416">Backend</text>
        <line x1="948" y1="306" x2="1252" y2="306" stroke="#ECEAE3"/>
        <text x="948" y="338" fontSize="13" fontWeight="600" fill="#8A887F" letterSpacing="0.04em">SUB-TASKS</text>
        <rect x="948" y="354" width="304" height="60" rx="12" fill="#FFFFFF" stroke="#E6E4DC"/>
        <text x="964" y="378" fontFamily="'Geist Mono', monospace" fontSize="11" fill="#8A887F">TASK-456</text>
        <text x="964" y="400" fontSize="14" fontWeight="500" fill="#141416">Card validation</text>
        <rect x="1178" y="372" width="60" height="24" rx="12" fill="#E4F5EB"/>
        <text x="1208" y="388" fontSize="11" fontWeight="600" fill="#18794E" textAnchor="middle">Done</text>
        <rect x="948" y="424" width="304" height="60" rx="12" fill="#FFFFFF" stroke="#E6E4DC"/>
        <text x="964" y="448" fontFamily="'Geist Mono', monospace" fontSize="11" fill="#8A887F">TASK-457</text>
        <text x="964" y="470" fontSize="14" fontWeight="500" fill="#141416">Payment provider callback</text>
        <rect x="1178" y="442" width="60" height="24" rx="12" fill="#FEF4DE"/>
        <text x="1208" y="458" fontSize="11" fontWeight="600" fill="#A15C07" textAnchor="middle">Doing</text>
        <rect x="948" y="494" width="304" height="60" rx="12" fill="#FFFFFF" stroke="#E6E4DC"/>
        <text x="964" y="518" fontFamily="'Geist Mono', monospace" fontSize="11" fill="#8A887F">TASK-458</text>
        <text x="964" y="540" fontSize="14" fontWeight="500" fill="#141416">Error states</text>
        <rect x="1178" y="512" width="60" height="24" rx="12" fill="#FDECEC"/>
        <text x="1208" y="528" fontSize="11" fontWeight="600" fill="#B42318" textAnchor="middle">To do</text>
        <g transform="translate(948 590)">
            <path d="M2 8a7 7 0 0 1 12-4l2 2M16 2v4h-4M16 10a7 7 0 0 1-12 4l-2-2M2 16v-4h4" fill="none"
                  stroke="#30A46C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            <text x="26" y="14" fontSize="13" fill="#5B5A62">Synced with Jira</text>
        </g>
    </svg>
);

export const HeroProductMockMobile = () => (
    <svg width="350" height="480" viewBox="0 0 350 480" role="img"
         aria-label="Ovalview project map on mobile, with a task's details open below"
         style={{display: 'block', fontFamily: "'Geist', sans-serif", width: '100%', height: 'auto'}}>
        <defs>
            <pattern id="ov-hero-m-dots" width="18" height="18" patternUnits="userSpaceOnUse">
                <circle cx="1" cy="1" r="1" fill="#E3E0D7"/>
            </pattern>
            <marker id="ov-hero-m-arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6"
                    orient="auto-start-reverse">
                <path d="M0 0L10 5L0 10z" fill="#8A877E"/>
            </marker>
        </defs>
        <rect width="350" height="480" fill="#FFFFFF"/>
        <g transform="translate(16 16)">
            <ellipse cx="6" cy="8" rx="5" ry="4" fill="#FDECEC" stroke="#E5484D" strokeWidth="1.4"/>
            <ellipse cx="11" cy="8" rx="5" ry="4" fill="#FEF4DE" stroke="#F5A524" strokeWidth="1.4"/>
            <ellipse cx="16" cy="8" rx="5" ry="4" fill="#E4F5EB" stroke="#30A46C" strokeWidth="1.4"/>
        </g>
        <text x="46" y="29" fontSize="14" fontWeight="600" fill="#141416">Checkout revamp</text>
        <Avatar cx={296} cy={24} r={12} fill="#6E56CF" initials="AK" fontSize={9}/>
        <Avatar cx={318} cy={24} r={12} fill="#0D74CE" initials="JM" fontSize={9}/>
        <line x1="0" y1="48" x2="350" y2="48" stroke="#ECEAE3"/>
        <rect x="0" y="49" width="350" height="431" fill="#FBFAF7"/>
        <rect x="0" y="49" width="350" height="431" fill="url(#ov-hero-m-dots)"/>
        <g fontFamily="'Geist Mono', monospace" fontSize="10" fill="#9A978D" textAnchor="middle" letterSpacing="0.06em">
            <text x="70" y="74">FRONTEND</text>
            <text x="175" y="74">BACKEND</text>
            <text x="280" y="74">QA</text>
        </g>
        <g stroke="#E4E1D8" strokeWidth="2">
            <line x1="70" y1="84" x2="70" y2="300"/>
            <line x1="175" y1="84" x2="175" y2="300"/>
            <line x1="280" y1="84" x2="280" y2="300"/>
        </g>
        <g fill="none" stroke="#8A877E" strokeWidth="1.8" markerEnd="url(#ov-hero-m-arrow)">
            <path d="M118 110 C 140 110, 132 160, 124 160"/>
            <path d="M70 130 L 70 188"/>
        </g>
        <g fill="none" stroke="#A9A69C" strokeWidth="1.8" strokeDasharray="5 5" markerEnd="url(#ov-hero-m-arrow)">
            <path d="M223 162 C 245 162, 238 210, 229 210"/>
            <path d="M118 212 C 140 212, 132 262, 124 262"/>
        </g>
        <StatusOval cx={70} cy={110} rx={48} ry={19} status="done" label="API contract" fontSize={12} strokeWidth={2.2}/>
        <ellipse cx="175" cy="160" rx="55" ry="26" fill="none" stroke="#3346E0" strokeWidth="1.4" strokeDasharray="4 4"/>
        <StatusOval cx={175} cy={160} rx={48} ry={19} status="doing" label="Payment flow" fontSize={12} strokeWidth={2.2}/>
        <StatusOval cx={70} cy={210} rx={48} ry={19} status="doing" label="Cart UI" fontSize={12} strokeWidth={2.2}/>
        <StatusOval cx={280} cy={210} rx={48} ry={19} status="todo" label="Regression" fontSize={12} strokeWidth={2.2}/>
        <StatusOval cx={175} cy={262} rx={48} ry={19} status="todo" label="Load test" fontSize={12} strokeWidth={2.2}/>
        <Avatar cx={218} cy={142} r={10} fill="#6E56CF" initials="AK" fontSize={8}/>
        <Avatar cx={113} cy={192} r={10} fill="#0D74CE" initials="JM" fontSize={8}/>
        <path d="M0 316 Q0 300 16 300 H334 Q350 300 350 316 V480 H0 Z" fill="#FFFFFF" stroke="#E6E4DC"/>
        <rect x="155" y="310" width="40" height="4" rx="2" fill="#DAD7CE"/>
        <text x="20" y="340" fontFamily="'Geist Mono', monospace" fontSize="11" fill="#8A887F">JRA-123</text>
        <text x="20" y="364" fontFamily="'Bricolage Grotesque', sans-serif" fontSize="20" fontWeight="700"
              fill="#141416">Payment flow</text>
        <rect x="236" y="346" width="96" height="24" rx="12" fill="#FEF4DE"/>
        <circle cx="249" cy="358" r="4" fill="#F5A524"/>
        <text x="258" y="362" fontSize="11" fontWeight="600" fill="#A15C07">In progress</text>
        <rect x="20" y="382" width="312" height="50" rx="12" fill="#FFFFFF" stroke="#E6E4DC"/>
        <text x="34" y="402" fontFamily="'Geist Mono', monospace" fontSize="10" fill="#8A887F">TASK-456</text>
        <text x="34" y="421" fontSize="13" fontWeight="500" fill="#141416">Card validation</text>
        <rect x="266" y="395" width="54" height="22" rx="11" fill="#E4F5EB"/>
        <text x="293" y="410" fontSize="10" fontWeight="600" fill="#18794E" textAnchor="middle">Done</text>
        <g transform="translate(20 448)">
            <path d="M2 8a7 7 0 0 1 12-4l2 2M16 2v4h-4M16 10a7 7 0 0 1-12 4l-2-2M2 16v-4h4" fill="none"
                  stroke="#30A46C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            <text x="26" y="14" fontSize="12" fill="#5B5A62">Synced with Jira</text>
        </g>
    </svg>
);
